export * from '@primeuix/themes/material/galleria';
export { default } from '@primeuix/themes/material/galleria';
